import { Link } from 'react-router-dom';

const HERO_BG = 'https://readdy.ai/api/search-image?query=warm%20professional%20child%20psychologist%20office%20with%20natural%20light%2C%20cozy%20evaluation%20room%20with%20colorful%20educational%20materials%2C%20wooden%20toys%20and%20books%20arranged%20on%20desk%2C%20soft%20sunlight%20streaming%20through%20window%2C%20inviting%20therapeutic%20space%20for%20children&width=1400&height=900&seq=hero001&orientation=landscape';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-navy-dark/85 via-navy-dark/60 to-navy-dark/30" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-16 md:pt-24 md:pb-20 w-full">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-coral/20 border border-coral/30 text-coral-light px-3 md:px-4 py-1.5 rounded-full text-xs font-600 font-sans mb-6 md:mb-8 backdrop-blur-sm">
            <i className="ri-shield-check-line" />
            Avaliação com Base Científica e Acolhimento
          </div>

          <h1 className="font-serif leading-tight mb-5 md:mb-6">
            <span className="block text-white/80 text-xl md:text-3xl font-300 italic mb-1">Entendendo seu filho</span>
            <span className="block text-white text-3xl md:text-5xl font-700">com ciência e<br />acolhimento</span>
            <span className="block text-coral-light text-lg md:text-2xl font-300 italic mt-2">um passo de cada vez.</span>
          </h1>

          <p className="text-white/75 text-base md:text-lg font-sans font-300 leading-relaxed mb-8 md:mb-10 max-w-xl">
            Sabemos que chegar até aqui exige coragem. Nossa avaliação neuropsicopedagógica é um processo 
            transparente, respeitoso e orientado para o que seu filho realmente precisa.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap gap-3 md:gap-4">
            <Link
              to="/jornada"
              className="inline-flex items-center justify-center gap-2 bg-coral text-white px-6 md:px-7 py-3 md:py-3.5 rounded-full font-sans font-600 text-sm whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-coral-dark hover:shadow-lg"
            >
              <i className="ri-route-line" />
              Conheça a Jornada
            </Link>
            <Link
              to="/pre-anamnese"
              className="inline-flex items-center justify-center gap-2 bg-white/15 backdrop-blur-sm text-white border border-white/30 px-6 md:px-7 py-3 md:py-3.5 rounded-full font-sans font-600 text-sm whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-white/25"
            >
              <i className="ri-file-list-3-line" />
              Iniciar Pré-Anamnese
            </Link>
          </div>

          <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8 md:mt-12">
            {[
              { icon: 'ri-brain-line', text: 'Protocolos validados cientificamente' },
              { icon: 'ri-shield-line', text: 'Conformidade LGPD' },
              { icon: 'ri-heart-line', text: 'Foco no acolhimento' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-white/70 text-xs font-sans">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-coral-light text-sm`} />
                </div>
                {item.text}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-cream to-transparent" />
    </section>
  );
}
